import useSWR from "swr";
import { customFetcher } from "../../../utils";
import { Employee } from "./ShiftScheduler";
import { ChoiceEmployee, Team } from "../../../globals/interfaces";
import { useEffect } from "react";

export default function useEmployeesData (
    runQuery: boolean,
    memberModified: number,
    selectedTeamId: number | undefined, 
    unit: string,
    currentWeek: string,
    endOfCurrentWeek: string
) {
    const {
        data: employeesWithShifts,
        mutate: mutateEmployeesWithShifts,
        isLoading,
        isValidating
    } = useSWR((runQuery && selectedTeamId) ? `/shift?teamId=${selectedTeamId}&startDate=${currentWeek}&endDate=${endOfCurrentWeek}` : null, customFetcher<Employee>, {
        fallbackData: []
    });

    const {
        data: employees
    } = useSWR(runQuery && `/team-member/employees/${unit}`, customFetcher<ChoiceEmployee>, {
        fallbackData: []
    });

    useEffect(() => {
        mutateEmployeesWithShifts();
    }, [memberModified]);

    return {
        employeesWithShifts,
        mutateEmployeesWithShifts,
        employees,
        isLoading,
        isValidating
    }
}